export const calculateDoblerielAmericano = (width, height) => {
  const verticalElements = {
    'Marco': Math.floor(height + 54),
    'Hoja Normal 1era Hoja': Math.floor(height - 49),
    'Hoja Normal 2da Hoja': Math.floor(height - 49),
    'Traslapo Movil': Math.floor(height - 49),
    'Hoja Movil': Math.floor(height - 49),
    'Refuerzo Hoja Movil': Math.floor(height - 60),
    'Refuerzo Hoja Normal': Math.floor(height - 60),
  };

  const horizontalElements = {
    'Marco': Math.floor(width + 54),
    'Hoja Normal 1era Hoja': Math.floor(width / 2 + 4),
    'Hoja Normal 2da Hoja': Math.floor(width / 2 - 18),
  };

  // Calcular barras necesarias
  const barrasNecesarias = {};
  const largoBarra = 6000; // mm

  // Cantidades específicas para cada perfil vertical
  const cantidadesVerticales = {
    'Marco': 2,
    'Hoja Normal 1era Hoja': 1,
    'Hoja Normal 2da Hoja': 1,
    'Traslapo Movil': 1,
    'Hoja Movil': 1,
    'Refuerzo Hoja Movil': 1,
    'Refuerzo Hoja Normal': 1
  };

  // Cantidades específicas para cada perfil horizontal
  const cantidadesHorizontales = {
    'Marco': 2,
    'Hoja Normal 1era Hoja': 2,
    'Hoja Normal 2da Hoja': 2
  };

  // Procesar elementos verticales
  for (const [perfil, largo] of Object.entries(verticalElements)) {
    const cantidadPiezas = cantidadesVerticales[perfil];
    const piezasVerticales = Array(cantidadPiezas).fill(largo);
    
    barrasNecesarias[perfil] = {
      cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
      desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
      piezasVerticales,
      piezasHorizontales: [],
      largoTotal: largo * cantidadPiezas
    };
  }

  // Procesar elementos horizontales
  for (const [perfil, largo] of Object.entries(horizontalElements)) {
    const cantidadPiezas = cantidadesHorizontales[perfil];
    const piezasHorizontales = Array(cantidadPiezas).fill(largo);
    
    if (!barrasNecesarias[perfil]) {
      barrasNecesarias[perfil] = {
        cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
        desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
        piezasVerticales: [],
        piezasHorizontales,
        largoTotal: largo * cantidadPiezas
      };
    } else {
      const largoTotalCombinado = (largo * cantidadPiezas) + barrasNecesarias[perfil].largoTotal;
      barrasNecesarias[perfil] = {
        ...barrasNecesarias[perfil],
        cantidadBarras: Math.ceil(largoTotalCombinado / largoBarra),
        desperdicioMm: (Math.ceil(largoTotalCombinado / largoBarra) * largoBarra) - largoTotalCombinado,
        piezasHorizontales,
        largoTotal: largoTotalCombinado
      };
    }
  }

  return {
    vertical: verticalElements,
    horizontal: horizontalElements,
    barrasNecesarias,
    type: 'Doble Riel Americano',
    photo: 'https://cdnx.jumpseller.com/alumsur/image/33028200/resize/960/960?1678476266',
  };
};

export const calculateVidriosDoblerielAmericano = (height, width) => {
  // Aseguramos que los valores sean números enteros
  const numericHeight = Math.floor(Number(height));
  const numericWidth = Math.floor(Number(width));

  return {
    movil1: {
      vertical: Math.floor(numericHeight - 102),
      horizontal: Math.floor(numericWidth / 2 - 55)
    },
    movil2: {
      vertical: Math.floor(numericHeight - 102),
      horizontal: Math.floor(numericWidth / 2 - 79)
    }
  };
};
